import type { RouteRecordNormalized } from 'vue-router';

const modules = require.context('./modules', false, /\.ts$/);
const externalModules = require.context('./externalModules', false, /\.ts$/);

function formatModules(_modules: __WebpackModuleApi.RequireContext, result: RouteRecordNormalized[]) {
  _modules.keys().forEach((key) => {
    const defaultModule = _modules(key).default;
    if (!defaultModule) return;
    const moduleList = Array.isArray(defaultModule)
      ? [...defaultModule]
      : [defaultModule];
    result.push(...moduleList);
  });
  return result;
}

export const appRoutes: RouteRecordNormalized[] = formatModules(modules, []);

export const appExternalRoutes: RouteRecordNormalized[] = formatModules(
  externalModules,
  []
);
